"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLogRocketCookie = exports.LOGROCKET_COOKIE = void 0;

var _storage = require("../storage");

var LOGROCKET_COOKIE = 'zola-lgrkt';
exports.LOGROCKET_COOKIE = LOGROCKET_COOKIE;

var setLogRocketCookie = function setLogRocketCookie(projectName) {
  var cookieDuration = 1 / 24 * (30 / 60); // Days / Hours * 30 Minutes

  (0, _storage.setCookie)(LOGROCKET_COOKIE, projectName, cookieDuration);
};

exports.setLogRocketCookie = setLogRocketCookie;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola-helpers/client/dist/es/util/logrocket/logRocketCookieUtils.js
// module id = 603
// module chunks = 71